import { render } from "./Services.vue?vue&type=template&id=71e2fdc6&scoped=true"
import script from "./Services.vue?vue&type=script&lang=js"
export * from "./Services.vue?vue&type=script&lang=js"

import "./Services.vue?vue&type=style&index=0&id=71e2fdc6&lang=scss&scoped=true"
import "./Services.vue?vue&type=style&index=1&id=71e2fdc6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e2fdc6"]])

export default __exports__